import { CSSProperties, ReactNode } from 'react';
import styles from 'styles/components/common/elements/SingleBtn.module.scss';

type TProps = {
  type?: 'button' | 'submit' | 'reset' | undefined;
  btnText: string;
  isBtnActive?: boolean;
  hasOutline?: boolean;
  hasActiveOutline?: boolean;
  disabled?: boolean;
  btnStyle?: CSSProperties;
  onClick?: () => void;
  icon?: ReactNode;
};

const SingleBtn = ({
  type,
  btnText,
  isBtnActive,
  hasOutline,
  hasActiveOutline,
  disabled,
  btnStyle,
  onClick,
  icon,
}: TProps) => {
  return (
    <button
      type={type || 'button'}
      className={
        hasActiveOutline
          ? disabled
            ? styles.btn_outline_disabled
            : styles.btn_active_outline
          : hasOutline
          ? disabled
            ? styles.btn_outline_disabled
            : styles.btn_outline
          : isBtnActive
          ? disabled
            ? styles.btn_active_disabled
            : styles.btn_active
          : disabled
          ? styles.btn_disabled
          : styles.btn
      }
      style={btnStyle}
      disabled={disabled}
      onClick={onClick}
    >
      {icon}
      {btnText}
    </button>
  );
};

export default SingleBtn;
